
import Moderator from '@/models/bread/Moderator/eventInstitutionGroup'


export default {
    key: 'EventInstitutionGroup',
    name: {
        singular: 'EventInstitutionGroup',
        plural: 'EventInstitutionGroups',
    },
    parents: [
        'Event',
    ],
    Admin: false,
    Moderator: Moderator,
    Teacher: false,
}